var service = {
    mapLibraries: ['places'],
    API_URL: process.env.REACT_APP_BACKEND_URL
};

if (process.env.NODE_ENV === 'production') {
    service.API_URL = process.env.REACT_APP_BACKEND_URL;
} else {
    service.API_URL = "http://192.168.29.7:5000";
    // service.API_URL = process.env.REACT_APP_BACKEND_URL;
}

export default service;
